import {Component, OnInit, Input, AfterViewInit, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Job} from '../jobs';
import {JobService} from '../jobs.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {RecordDataComponent} from "../../../../components/record-data";
import {ItemService} from "../../items/items.service";
import {ConfirmDialogModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {CommonModule} from "@angular/common";
import {DropdownModule} from "primeng/primeng";

import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ItemsShowComponent} from "../../items/items-show/items-show.component";
import {AppArcComponent} from "../../../../components/app-arc";
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        JobsShowComponent
    ],
    entryComponents: [
        JobsShowComponent
    ],
    exports: [],
    providers: [SharedService, JobService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-jobs-show',
    templateUrl: './jobs-show.component.html',
    styleUrls: ['./jobs-show.component.scss'],
    providers: [JobService, ConfirmationService, MessageService]
})

export class JobsShowComponent implements OnInit, AfterViewInit {
    id: string;
    job: Job;
    applog: AppLogComponent;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() modelName;
    @Input() scrId;

    jobForm: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private jobService: JobService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private modalService: NgbModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('');
    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.job;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        if(!this.scrId) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/jobs/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteJob(this.job);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/jobs']);
                });
            }

            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/jobs/search']);
                });

            }
        }
    }

    ngOnInit() {

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.jobForm = new FormGroup({
            id: new FormControl({value: '', disabled: true}, Validators.required),
            name: new FormControl({value: '', disabled: true}, Validators.required),
            address: new FormControl({value: '', disabled: true}, Validators.required),
            telephone: new FormControl({value: '', disabled: true}, Validators.required),
            fax: new FormControl({value: '', disabled: true}, Validators.required),
            status: new FormControl({value: '', disabled: true}, Validators.required),

        });

        if (this.id) {
            this.msgs = [];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];

            }
            this.jobService.getById(this.id).subscribe(
                job => {
                    this.id = job.id;
                    this.job = job;
                    this.jobForm.patchValue({
                        id: job.id,
                        name: job.name,
                        address: job.address,
                        telephone: job.telephone,
                        fax: job.fax,

                        status: job.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.scrId) {
            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.jobService.getById(this.scrId).subscribe(
                job => {
                    this.id = job.id;
                    this.job = job;
                    this.jobForm.patchValue({
                        id: job.id,
                        name: job.name,
                        address: job.address,
                        telephone: job.telephone,
                        fax: job.fax,

                        status: job.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.jobService.getTrashedById(this.delId).subscribe(
                job => {
                    this.id = job.id;
                    this.job = job;
                    this.jobForm.patchValue({
                        id: job.id,
                        name: job.name,
                        address: job.address,
                        telephone: job.telephone,
                        fax: job.fax,

                        status: job.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }


        if (this.oldData && this.newData) {
            this.job = this.newData;
            this.jobForm.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                address: this.newData.address,
                telephone: this.newData.telephone,
                fax: this.newData.fax,

                status: this.newData.status,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.jobs.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteJob(job: Job) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (job) {
                    this.jobService.delete(job.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(() => {
                                this.router.navigate(['/jobs']);
                            },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    recoverEdit(job: Job) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (job) {
                    this.jobService.update(job).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/jobs/show', job.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.jobService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/jobs/list']);
                        }
                    );
                }
            }
        });
    }


    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = JobsShowComponent;

        }
    }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/jobs/jobs-show/jobs-show.component.ts